import { Emoji, emojiByUnified, EmojiStyle } from 'emoji-picker-react'

const FOLDER_EMOJI_UNIFIED = '1f4c1'

interface FavoriteViewEmojiRendererProps {
  unified: string | null | undefined
  size: number
}

export function FavoriteViewEmojiRenderer({ unified, size }: Readonly<FavoriteViewEmojiRendererProps>) {
  const emojiUnified = unified && emojiByUnified(unified) ? unified : FOLDER_EMOJI_UNIFIED

  return (
    <span className="favorite-view-panel__folder-emoji" aria-hidden="true">
      <Emoji unified={emojiUnified} emojiStyle={EmojiStyle.NATIVE} size={size} />
    </span>
  )
}
